/**
 * 隣接テキストの textContent 食い込み防止用中黒。
 * 見た目は隠し、aria-hidden で見出し・ボタン名の読み上げにも載せない。
 */
export default function TextContentSep() {
  return (
    <span className="visually-hidden" aria-hidden="true">
      {' · '}
    </span>
  );
}

/** DataTables 等の HTML 文字列用 */
export const TEXT_CONTENT_SEP_HTML =
  '<span class="visually-hidden" aria-hidden="true"> · </span>';
